import {Injectable} from '@angular/core';
import {Http, Headers} from '@angular/http';
import {environment} from '../../environments/environment';
import {NgRedux} from '@angular-redux/store';
import {IAppState} from '../reducers/root.reducer';

const ACCESS_TOKEN = environment.mapboxAccessToken;

@Injectable()
export class ApiService {
  headers = new Headers();

  constructor(private http: Http, private ngRedux: NgRedux<IAppState>) {
    this.headers.append('Content-Type', 'application/json');
  }

  search(term: string, language: string) {
    if (term) {
      let url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${term}.json`;
      url += `?autocomplete=true&country=be&language=${language}&types=place,address&access_token=${ACCESS_TOKEN}`;
      return this.http.get(url).map(response => response.json());
    } else {
      return [];
    }
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Angular_wig_cropmap_master/src/app/services/api.service.ts